import { DomainEvent } from '@swoft/core';

/**
 * Domain event raised when a task is assigned to a developer.
 * 
 * This event triggers workflow automation and notification systems
 * to update project tracking and developer workload management.
 */
export class TaskAssigned implements DomainEvent {
  readonly type = 'TaskAssigned';
  readonly eventType = 'TaskAssigned';
  readonly occurredOn: Date;
  readonly occurredAt: Date;
  readonly eventVersion = 1;

  constructor(
    public readonly aggregateId: string,
    public readonly partyId: string,
    public readonly roleType: string,
    public readonly assignedAt: Date = new Date()
  ) {
    this.occurredOn = this.assignedAt;
    this.occurredAt = this.assignedAt;
  }

  /**
   * Create event from legacy format for migration compatibility.
   */
  static fromLegacy(
    taskId: string,
    partyId: string,
    roleType: string,
    assignedAt: string
  ): TaskAssigned {
    return new TaskAssigned(
      taskId,
      partyId,
      roleType,
      new Date(assignedAt)
    );
  }
}
